<div class="DocContainer">
    <div class="LeftFacet">
        <ng-container *ngIf="this.productListService.selectedTabIndex| async as tabIndex">
            <ng-container *ngIf="tabIndex === 7">
                <app-facet-navigation></app-facet-navigation>
            </ng-container>
        </ng-container>
    </div>
    <div class="rightSectionDoc">
        <div class="formSectionTop">
            <h1 class="myProfileTopHeader m-0">
                {{'common.document_library_text_document'|cxTranslate}}
            </h1>
            <div class="myProfileBody">
                <form [formGroup]="docSearchForm" (ngSubmit)="search(0,defaultPageSize,'')">
                    <div class="row document-search-section">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                            <label class="software-search-label"
                                for="search">{{'common.search_meta_title'|cxTranslate}}</label>
                            <div class="col-12 px-0 docInputSearch">
                                <input #searchInput type="text" formControlName="searchKey"
                                    (input)="onSearchInput($event)"
                                    (keydown.enter)=" onSearchInput($event);onSearch($event);clearRecentSearch()"
                                    (keyup)="onSearchInput($event)" (focus)="onSearchInput($event)"
                                    (click)="onSearchInput($event)"
                                    [placeholder]="'common.document_library_placeholder_text'|cxTranslate">
                                <ul class="RecentSearch RecentSearchDOCPopUP" *ngIf="recentSearches.length > 0">
                                    <p class="RecentSearchText">{{'common.recent_search'|cxTranslate}}</p>
                                    <p *ngFor="let search of recentSearches" class="RecentSearch-item">
                                        <a (click)="populateSearchInput(search.value)"
                                            class="RecentSearch-anchor">{{search.value}}</a>
                                    </p>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                            <label class="software-search-label"
                                for="select">{{'common.document_library_text_document_category'|cxTranslate}}</label>
                            <div class="selectBox"><select formControlName="productCategory">
                                    <option value="null" [selected]="form.productCategory.value==null">
                                        {{'common.form_select_empty'|cxTranslate}}</option>
                                    <option *ngFor="let item of ApiDataSearch?.documentCategoryList" [value]="item">
                                        {{item}}</option>
                                </select></div>
                        </div>
                    </div>
                    <div class="row document-search-section">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                            <label class="software-search-label"
                                for="select">{{'common.document_library_text_document_type'|cxTranslate}}</label>
                            <div class="selectBox"><select formControlName="docType">
                                    <option value="null" [selected]="form.docType.value==null">
                                        {{'common.form_select_empty'|cxTranslate}}</option>
                                    <option *ngFor="let item of ApiDataSearch?.documentTypeDataList "
                                        [value]="item?.documentCode">
                                        {{item?.documentNameLoc}}</option>
                                </select></div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 form-group">
                            <label class="software-search-label"
                                for="select">{{'common.document_library_text_language'|cxTranslate}}</label>
                            <div class="selectBox"><select formControlName="language">
                                    <option value="null" [selected]="form.language.value==null">
                                        {{'common.form_select_empty'|cxTranslate}}</option>
                                    <option *ngFor="let item of ApiDataSearch?.langaugeList " [value]="item">{{item}}
                                    </option>
                                </select></div>
                        </div>
                    </div>
                    <div class="buttonsContainer mt-4">
                        <div>
                            <button (click)="reset()" type="button"
                                class="btn btn-blue reset-btn">{{'common.text_account_reset'|cxTranslate}}</button>
                        </div>
                        <div class="">
                            <button class="btn btn-primary-new search-btn"
                                type="submit">{{'common.search_meta_title'|cxTranslate}}
                                <img src="/icons/link-grey.svg" width="20px" alt=""></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="bottomSectionPDP">
            <section class="cx-page-section">
                <div class="container1" *ngIf="productListService.seperateDocDetails$|async as docModel">
                    <div class="row1" *ngIf="docModel?.documentsCounts ; else noData">
                        <div class="" *ngIf="viewMode$ | async as viewMode">
                            <div class="cx-sorting top">
                                <div class="action-row sorting-block">
                                    <label
                                        class="d-none d-md-none d-lg-block col-lg-3 total-records">{{docModel.pagination.totalResults}}
                                        {{'common.search_page_totalResults'|cxTranslate}}</label>
                                    <label class="col-lg-3 pagination"
                                        *ngIf="docModel.pagination.totalResults >90 || docModel.pagination.totalResults >30">{{'common.pagination_view'
                                        | cxTranslate}}
                                        <a *ngIf="docModel.pagination.totalResults >30" class="page-size"
                                            [routerLink]="" (click)="changePageSize(30,docModel)"> &nbsp;30&nbsp;
                                        </a> <span
                                            *ngIf="docModel.pagination.totalResults >90">{{'common.pagination_or'|cxTranslate}}
                                            <a class="page-size" [routerLink]="" (click)="changePageSize(90,docModel)">
                                                &nbsp;90&nbsp;
                                            </a></span>
                                        {{'common.pagination_items' | cxTranslate}}</label>
                                    <div class="sort-select" *ngIf="!isMobile">
                                        <label class="sort-by" *ngIf="docModel?.sorts?.length >=1">
                                            <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                                        </label>
                                        <div class="col-lg-4 sorting"
                                            *ngIf="docModel?.sorts?.length >=1;else noSorting">
                                            <cx-sorting [sortOptions]="docModel.sorts"
                                                (sortListEvent)="sortList($event, docModel)"
                                                [selectedOption]="docModel.pagination?.sort"
                                                [ariaLabel]="'productList.sortResults' | cxTranslate"
                                                ariaControls="product-results-list"
                                                placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                                            </cx-sorting>
                                        </div>
                                        <ng-template #noSorting>
                                            <div class="col-lg-4 sorting">

                                            </div>
                                        </ng-template>
                                    </div>
                                    <div class="d-flex col-12 doc-search-filter" *ngIf="isMobile">
                                        <div class="col-4 doc-left-search-filter" *ngIf="docModel?.facets?.length >=1">
                                            <app-facet-navigation></app-facet-navigation>
                                        </div>
                                        <div class=" col-8 sort-select" *ngIf="docModel?.sorts?.length >=1">
                                            <label class="sort-by" *ngIf="docModel?.sorts?.length >=1">
                                                <span>{{'common.search_page_sortTitle'|cxTranslate}}</span>
                                            </label>
                                            <div class=" sorting" *ngIf="docModel?.sorts?.length >=1;else noSorting">
                                                <cx-sorting [sortOptions]="docModel.sorts"
                                                    (sortListEvent)="sortList($event, docModel)"
                                                    [selectedOption]="docModel.pagination?.sort"
                                                    [ariaLabel]="'productList.sortResults' | cxTranslate"
                                                    ariaControls="product-results-list"
                                                    placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                                                </cx-sorting>
                                            </div>
                                            <ng-template #noSorting>
                                                <div class=" sorting">

                                                </div>
                                            </ng-template>
                                        </div>
                                    </div>
                                    <div class="col-lg-1 no-padding d-flex justify-content-end switch-btn">
                                        <cx-product-view (modeChange)="setViewMode($event)"
                                            [mode]="viewMode"></cx-product-view>
                                    </div>
                                </div>
                            </div>
                            <div id="product-results-list" class="cx-product-container">
                                <!-- Product list when using pagination -->
                                <ng-container *ngIf="!isInfiniteScroll; else infiniteScroll">
                                    <ng-container *ngIf="viewMode === ViewModes.Grid">
                                        <div class="row">
                                            <app-kb-document-grid *ngFor="let product of docModel?.documents"
                                                [product]="product" [searchQuery]="SearchQuery"
                                                class="col-12 col-sm-12 col-md-12 col-lg-3"></app-kb-document-grid>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="viewMode === ViewModes.List">
                                        <app-kb-document-list *ngFor="let product of docModel?.documents"
                                            [product]="product" [searchQuery]="SearchQuery"
                                            class="cx-product-search-list">
                                        </app-kb-document-list>
                                    </ng-container>
                                </ng-container>
                                <!-- Product list when using infinite scroll -->
                                <ng-template #infiniteScroll>
                                    <cx-product-scroll [scrollConfig]="scrollConfig" [model]="docModel"
                                        [inputViewMode]="viewMode"></cx-product-scroll>
                                </ng-template>
                            </div>
                            <div class="cx-sorting bottom">
                                <div class="row col-md-12">
                                    <label class="col-md-5">{{'common.search_page_showing_text'|cxTranslate}}
                                        {{(docModel.pagination.pageSize *
                                        docModel.pagination.currentPage)+1 }}-
                                        <span
                                            *ngIf="docModel.pagination.pageSize *(docModel.pagination.currentPage+1) < docModel.pagination.totalResults">{{docModel.pagination.pageSize
                                            *(docModel.pagination.currentPage+1)}}</span>
                                        <span
                                            *ngIf="docModel.pagination.pageSize *(docModel.pagination.currentPage+1) > docModel.pagination.totalResults">{{docModel.pagination.totalResults}}</span>
                                        {{'common.search_page_of_text'|cxTranslate}}
                                        {{docModel.pagination.totalResults}}
                                        {{'common.search_page_result_text'|cxTranslate}}</label>
                                    <div *ngIf="!isInfiniteScroll"
                                        class="col-auto col-md-7 d-flex justify-content-end align-items-center pr"
                                        [attr.aria-label]="'productList.productSearchPagination' | cxTranslate">
                                        <div class="kb-pagination">
                                            <kb-pagination [pagination]="docModel.pagination" [defaultPage]="0"
                                                (viewPageEvent)="changePageCustom($event,docModel)"></kb-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #noData>
                    <div class="document-not-found">{{'common.text_account_core_search_noRequestFound'|cxTranslate}}
                    </div>
                </ng-template>
            </section>
        </div>
    </div>
</div>